import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
// import { FreeMode } from "swiper";
import {
  Card,
  Row,
  Col,
  CardBody,
  CardImg,
  Badge,
  Input,
  Pagination,
  PaginationItem,
  PaginationLink,
} from "reactstrap";
import image1 from "../../../../assets/orderingSystem/burger.jpeg";
import { useEffect, useState } from "react";
import ProductDetailModal from "./component/ProductDetailModal";
import ProductItemServices from "../../../../services/OrderingServices/ProductItemService";
import restro from "../../../../assets/orderingSystem/restrologo.png";
import SmallScreenProductDetail from "./component/SmallScreenProductDetail";
import useIsMobile from "../../../../Components/Common/MobileScreen";
import CategoryServices from "../../../../services/OrderingServices/CategoryService";
import ItemService from "../../../../services/OrderingServices/ItemService";

const ProductPage = ({
  setSelectedItem,
  selectedItem,
  setCount,
  setComplimentaryCount,
  count,
  setSelectedAttributes,
  selectedAttributes,
  handleAddToCart,
  setNotes,
  notes,
  isModalOpen,
  setIsModalOpen,
  setComplementary,
  complementary,
  loading,
  toggleOrderSummary,
  setSelectedTable,
  selectedTable,
  orderData,
  setSelectedChildAttributes,
  selectedChildAttributes,
}) => {
  // console.log("🚀 ~ ProductPage ~ orderData:", orderData);
  const orderLength = orderData?.[selectedTable?.id]?.items;
  // console.log("🚀 ~ ProductPage ~ orderLength:", orderLength);

  const [categoryData, setCategoryData] = useState([]);
  const [productData, setProductData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(12);
  const [searchedText, setSearchedText] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("All Menu");
  const [isProductLoading, setIsProductLoading] = useState(false);
  const [debouncedFilters, setDebouncedFilters] = useState({
    namesearch: "",
    categoryId: "",
    PriceMin: "",
    PriceMax: "",
  });
  const [maxHeight, setMaxHeight] = useState(window.innerHeight * 0.75);

  // Fetch categories
  useEffect(() => {
    const fetchCategory = async () => {
      try {
        const response = await CategoryServices.maincategory();
        setCategoryData(response);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategory();
  }, []);

  // Debounce filter changes
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedFilters({
        namesearch: searchedText,
        categoryId: selectedCategory === "All Menu" ? "" : selectedCategory,
        PriceMin: "",
        PriceMax: "",
      });
      setCurrentPage(1); // Reset to first page on filter change
    }, 500);

    return () => clearTimeout(handler);
  }, [searchedText, selectedCategory]);

  // Fetch products with server-side pagination and filtering
  useEffect(() => {
    const fetchProduct = async () => {
      setIsProductLoading(true);
      try {
        const response = await ItemService.itemList({
          namesearch: debouncedFilters.namesearch,
          PriceMin: debouncedFilters.PriceMin,
          PriceMax: debouncedFilters.PriceMax,
          categoryId: debouncedFilters.categoryId,
          page: currentPage,
          pageSize: pageSize,
          fetchHidden: true,
        });
        const indexedData = response?.items.map((item, index) => ({
          ...item,
          sn: (currentPage - 1) * pageSize + index + 1,
        }));

        setProductData(indexedData);
        setTotalRows(response?.totalCount || 0);
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        setIsProductLoading(false);
      }
    };

    fetchProduct();
  }, [currentPage, pageSize, debouncedFilters]);

  // Handle window resize for maxHeight
  useEffect(() => {
    const handleResize = () => {
      setMaxHeight(window.innerHeight * 0.75);
    };

    window.addEventListener("resize", handleResize);

    // Call it once initially to set the height
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const isMobile = useIsMobile();

  // Toggle modal for product details
  const toggleModal = (item) => {
    setSelectedItem(item);
    setIsModalOpen(!isModalOpen);
  };

  // Pagination controls
  const totalPages = Math.ceil(totalRows / pageSize);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  // Skeleton Card Component
  const SkeletonCard = () => (
    <Col lg={3} md={6} sm={6} xs={6}>
      <Card className="border-0 h-100 rounded-3 shadow-sm">
        <CardBody className="d-flex flex-column justify-content-between p-3">
          <div className="d-flex justify-content-center mb-2">
            <div className="skeleton skeleton-image" />
          </div>
          <div className="skeleton skeleton-text" />
          <div className="d-flex justify-content-between align-items-center">
            <div className="skeleton skeleton-badge" />
            <div className="skeleton skeleton-price" />
          </div>
        </CardBody>
      </Card>
    </Col>
  );

  return (
    <div className="px-lg-3 px-0">
      {/* Category Swiper */}
      <div className="sticky-top z-2">
        <Swiper
          spaceBetween={12}
          freeMode={true}
          className="mySwiper"
          breakpoints={{
            320: { slidesPerView: 2 },
            480: { slidesPerView: 3 },
            640: { slidesPerView: 2 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 5 },
          }}
        >
          <SwiperSlide onClick={() => setSelectedCategory("All Menu")}>
            <Card
              className={`p-1 rounded-3 text-center shadow-sm border ${
                selectedCategory === "All Menu"
                  ? "border-primary"
                  : "border-light-subtle"
              }`}
              style={{ cursor: "pointer" }}
            >
              <Row>
                <Col lg={5} md={5} xs={5}>
                  <CardImg
                    src={restro}
                    alt=""
                    className="img-fluid rounded-3 bg-light p-1"
                    style={{
                      objectFit: "contain",
                      width: "100%",
                    }}
                  />
                </Col>
                <Col lg={7} md={7} xs={7}>
                  <div className="text-start  h-100 d-flex justify-content-start align-content-center align-items-center">
                    <h6 className="mb-1 text-truncate">All Menu</h6>
                    {/* <small>All items</small> */}
                  </div>
                </Col>
              </Row>
            </Card>
          </SwiperSlide>
          {categoryData?.items?.map((item, index) => (
            <SwiperSlide
              key={index}
              onClick={() => setSelectedCategory(item.id)}
            >
              <Card
                className={`p-1 rounded-3 text-center shadow-sm border ${
                  selectedCategory === item.id
                    ? "border-primary"
                    : "border-light-subtle"
                }`}
                style={{ cursor: "pointer" }}
              >
                <Row>
                  <Col lg={5} md={5} xs={5}>
                    <CardImg
                      src={restro}
                      alt=""
                      className="img-fluid rounded-3 bg-light p-1"
                      style={{
                        objectFit: "contain",
                        width: "100%",
                      }}
                    />
                  </Col>
                  <Col lg={7} md={7} xs={7}>
                    <div className="text-start  h-100 d-flex justify-content-start align-content-center align-items-center">
                      <h6 className="mb-1 text-wrap">{item.name}</h6>
                      {/* <small>{item.noOfItems} items</small> */}
                    </div>
                  </Col>
                </Row>
              </Card>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Search Input */}
        <div>
          <Row className="align-items-center mb-3 rounded-top sticky-top bg-light">
            <Col xs={12} lg={4} className="mb-2">
              <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                <h4 className="fw-bold mb-0">Menu</h4>
              </div>
            </Col>

            <Col xs={12} md={12} lg={8} className="">
              <div className="d-flex justify-content-between align-content-center align-items-center gap-lg-0 gap-2">
                <div className="position-relative w-100  ">
                  <i className="ri-search-line position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
                  <Input
                    type="text"
                    placeholder="Search menu..."
                    value={searchedText}
                    onChange={(e) => setSearchedText(e.target.value)}
                    className="ps-5 py-2 rounded-3 border shadow-sm"
                    style={{ fontSize: "14px" }}
                  />
                  {searchedText && (
                    <i
                      className="ri-close-line position-absolute top-50 end-0 translate-middle-y me-3 text-danger cursor-pointer"
                      onClick={() => setSearchedText("")}
                    ></i>
                  )}
                </div>
                <div className="d-lg-none d-md-none d-flex p-0">
                  <button
                    className="btn  btn-topbar btn-soft-success rounded-circle"
                    onClick={toggleOrderSummary}
                  >
                    <i className="ri-shopping-bag-3-line "></i>
                    {orderLength?.length > 0 && (
                      <span className="position-absolute topbar-badge fs-10 translate-middle badge rounded-pill bg-danger">
                        {orderLength?.length}
                      </span>
                    )}
                  </button>
                </div>
              </div>
            </Col>
          </Row>
        </div>

        {/* Product Grid */}
        <Row className="gx-3 gy-4 mb-3">
          {isProductLoading ? (
            // Render 8 skeleton cards
            [...Array(8)].map((_, index) => <SkeletonCard key={index} />)
          ) : productData.length ? (
            productData.map((item, index) => (
              <Col key={index} lg={3} md={6} sm={6} xs={6}>
                <Card
                  className="border-0 h-100 rounded-3 shadow-sm position-relative hover-scale cursor-pointer"
                  style={{
                    transition: "transform 0.2s ease-in-out",
                  }}
                >
                  <CardBody
                    className="d-flex flex-column justify-content-between p-3 cursor-pointer"
                    onClick={() => {
                      handleAddToCart(item); // ✅ pass item here
                    }}
                  >
                    <div className="d-flex justify-content-center mb-2">
                      <img
                        src={item?.image || restro}
                        alt={item.name}
                        className="img-fluid rounded object-fit-contain rounded-4"
                        style={{
                          height: "120px",
                          width: "100%",
                          objectFit: "contain",
                        }}
                      />
                    </div>
                    <h6 className="text-center fw-semibold mb-1 text-truncate">
                      {item.name}
                    </h6>
                    <div className="d-flex justify-content-between align-items-center">
                      {/* <Badge color="info" pill className="text-truncate px-2">
                        {item?.categoryName}
                      </Badge> */}
                      <span className="fw-bold text-dark">
                        Rs. {item.price}
                      </span>
                      <div>
                        <button
                          className="btn btn-soft-success btn-sm"
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleModal(item);
                          }}
                        >
                          <i class="ri-eye-2-line"></i>{" "}
                        </button>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            ))
          ) : (
            <Col xs={12}>
              <div className="text-center py-5 text-muted">
                <i className="ri-emotion-unhappy-line display-4 text-secondary mb-2"></i>
                <h5 className="fw-semibold">No items match your search</h5>
                <p className="small text-muted">
                  Try a different keyword or filter.
                </p>
              </div>
            </Col>
          )}
        </Row>

        {/* Pagination Controls */}
        {totalRows > 0 && !isProductLoading && (
          <Row className="sticky-bottom">
            <Col xs={12} className="d-flex justify-content-center">
              <Pagination color="success">
                {/* Previous button */}
                <PaginationItem disabled={currentPage === 1}>
                  <PaginationLink
                    onClick={() => handlePageChange(currentPage - 1)}
                    previous
                  />
                </PaginationItem>

                {(() => {
                  const maxPagesToShow = 5;
                  const half = Math.floor(maxPagesToShow / 2);

                  let startPage = Math.max(currentPage - half, 1);
                  let endPage = startPage + maxPagesToShow - 1;

                  if (endPage > totalPages) {
                    endPage = totalPages;
                    startPage = Math.max(endPage - maxPagesToShow + 1, 1);
                  }

                  const pageNumbers = [];
                  for (let i = startPage; i <= endPage; i++) {
                    pageNumbers.push(
                      <PaginationItem key={i} active={i === currentPage}>
                        <PaginationLink onClick={() => handlePageChange(i)}>
                          {i}
                        </PaginationLink>
                      </PaginationItem>
                    );
                  }
                  return pageNumbers;
                })()}

                {/* Next button */}
                <PaginationItem disabled={currentPage === totalPages}>
                  <PaginationLink
                    onClick={() => handlePageChange(currentPage + 1)}
                    next
                  />
                </PaginationItem>
              </Pagination>
            </Col>
          </Row>
        )}
      </div>

      {isMobile ? (
        <SmallScreenProductDetail
          isOpen={isModalOpen}
          toggle={toggleModal}
          selectedItem={selectedItem}
          setCount={setCount}
          setComplimentaryCount={setComplimentaryCount}
          count={count}
          setNotes={setNotes}
          setSelectedAttributes={setSelectedAttributes}
          selectedAttributes={selectedAttributes}
          handleAddToCart={handleAddToCart}
          setComplementary={setComplementary}
          complementary={complementary}
          loading={loading}
          notes={notes}
          setSelectedChildAttributes={setSelectedChildAttributes}
          selectedChildAttributes={selectedChildAttributes}
        />
      ) : (
        <ProductDetailModal
          isOpen={isModalOpen}
          toggle={toggleModal}
          selectedItem={selectedItem}
          setCount={setCount}
          setComplimentaryCount={setComplimentaryCount}
          count={count}
          setNotes={setNotes}
          setSelectedAttributes={setSelectedAttributes}
          selectedAttributes={selectedAttributes}
          handleAddToCart={handleAddToCart}
          setComplementary={setComplementary}
          complementary={complementary}
          loading={loading}
          notes={notes}
          setSelectedChildAttributes={setSelectedChildAttributes}
          selectedChildAttributes={selectedChildAttributes}
        />
      )}
    </div>
  );
};

export default ProductPage;
